import { render, staticRenderFns } from "./LetterTemplate.vue?vue&type=template&id=64c6219a&lang=pug&"
import script from "./LetterTemplate.vue?vue&type=script&lang=js&"
export * from "./LetterTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports